export default {
  projectDesc: '基于 <strong>Vue2</strong> 的简洁而强大的弹出窗口<br>包含了 模态窗口(Modal)、消息对话框(Alert)、遮罩(Mask)、边角提示框(Toast)等类型',
  iconTitle: '对话框图标',
  alertIcon: '在消息对话框（Alert）中使用的图标来自于',
  toastIcon: '操作按钮图标以及边角窗口（Toast）中使用的图标来自于',
  demo: {
    instanceName: '指定插件实例名，默认情况下使用 <code>$dlg</code> 作为实例名且仅能在插件注册时进行设置',
    modalTitle: '在模态窗口中载入模块（页面）',
    alertTitle: '弹出消息对话框，包含 info, warning, error, success, confirm 等类型',
    maskTitle: '弹出一个全屏遮罩',
    toastTitle: '弹出一个边角对话框, 包含 4 种消息类型和 6 个角落位置',
    vuexInModal: '在 Modal 内部的组件/页面中使用 <strong>Vuex</strong>',
    helper: {
      title: '工具集',
      close: '关闭一个指定键值的窗口，若不指定键值，则关闭最后一个打开的窗口',
      closeAll: '一次性关闭所有弹出窗口'
    }
  },
  option: {
    message: '对话框中显示的文本内容，支持 HTML 标签',
    messageType: '对话框消息类型',
    title: '模态窗口标题栏显示的标题内容，可设置为 <code>false</code> 来关闭标题栏',
    width: '窗口宽度',
    height: '窗口高度',
    params: '向模态窗口载入的页面传递参数，在载入的页面中设置 <code>props:{ xxx: Type }</code> 来获取传递的参数',
    closeButton: '关闭按钮是否显示',
    maxButton: '最大化窗口按钮是否显示',
    position: '边角位置指定',
    singletonKey: '为窗口设置一个键值，保证该键值的窗口只会被打开一个',
    language: '窗口使用语言',
    icon: '显示消息类型图标',
    customClass: '自定义样式名',
    shaking: '对话框之外的区域点击时，是否让对话框显示抖动的动画',
    closeTime: '自动关闭窗口时间（单位：秒）, 设置为 <code>false</code> 以禁用自动关闭窗口功能',
    cancelCallback: '关闭窗口的回调, 在以下的情况下触发: \n' +
          '点击右上角的关闭按钮 (Model,Toast 模式下)\n' +
          '在消息对话框（Alert）的 <kbd>confirm</kbd> 模式下，点击 "cancel" 按钮',
    fullscreen: '以最大化形式打开窗口'
  },
  api: {
    close: '关闭窗口，需要指定需要关闭窗口的编码',
    closeAll: '关闭全部窗口'
  }
}
